import { SystemField } from "./system-field";

export class InvAdjDetail extends SystemField{ 
     product_id?:string;
     trans_uom_id?:string;
     base_uom_id?:string;
     qty?:number;
     location_id?:string;
     warehouse_id?:string;
     unit_cost?:number;
     inv_adj_id?:string;
     langs?:any;
}
export class InvAdjDetailTranslate extends SystemField{ 
     lang_code?:string;
     description?:string;
     inv_adj_detail_id?:string;
}
